import { render, staticRenderFns } from "./SegmentSendEmail.vue?vue&type=template&id=9a14c750&scoped=true&lang=pug&"
import script from "./SegmentSendEmail.vue?vue&type=script&lang=js&"
export * from "./SegmentSendEmail.vue?vue&type=script&lang=js&"
import style0 from "./SegmentSendEmail.vue?vue&type=style&index=0&id=9a14c750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a14c750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VBtn,VCol,VContainer,VDivider,VRow,VTextField})
